interface ThemeMode {
  card_bg_color?: string;
  font_color?: string;
  primary_accent?: string;
}

interface ThemeConfig {
  fonts?: { heading?: string; body?: string };
  logo?: { primary?: string };
  modes?: { light?: ThemeMode; dark?: ThemeMode };
}

const defaults = {
  '--brand': '#6366f1',
  '--module-bg': '#6366f1',
  '--module-txt': '#fefefe',
  '--theme-accent': '#6366f1',
  '--theme-card-bg': '#ffffff',
  '--theme-font-color': '#1a1a1a',
  '--theme-accent-dark': '#3793ff',
  '--theme-card-bg-dark': '#121212',
  '--theme-font-color-dark': '#f5f5f5',
  '--theme-heading-font': 'inherit',
  '--theme-body-font': 'inherit',
};

export function applyTheme(configStr: string | ThemeConfig | null | undefined) {
  if (!configStr) {
    Object.entries(defaults).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
    return;
  }

  const config: ThemeConfig = typeof configStr === 'string' ? JSON.parse(configStr) : configStr;

  const set = (v: string, val?: string) => val && document.documentElement.style.setProperty(v, val);

  const light = config.modes?.light;
  const dark = config.modes?.dark;

  // Keep existing vars in sync
  set('--brand', dark?.primary_accent);
  set('--module-bg', dark?.card_bg_color);
  set('--module-txt', dark?.font_color);

  // New theme vars — light
  set('--theme-accent', light?.primary_accent);
  set('--theme-card-bg', light?.card_bg_color);
  set('--theme-font-color', light?.font_color);

  // New theme vars — dark
  set('--theme-accent-dark', dark?.primary_accent);
  set('--theme-card-bg-dark', dark?.card_bg_color);
  set('--theme-font-color-dark', dark?.font_color);

  // Fonts
  set('--theme-heading-font', config.fonts?.heading);
  set('--theme-body-font', config.fonts?.body);

  // Load Google Fonts
  const fontFamilies = [config.fonts?.heading, config.fonts?.body]
    .filter(Boolean)
    .map(f => f!.split(',')[0].trim().replace(/ /g, '+'));

  if (fontFamilies.length) {
    const id = 'theme-google-fonts';
    const existing = document.getElementById(id);
    const href = `https://fonts.googleapis.com/css2?${fontFamilies
      .map(f => `family=${f}:wght@400;600;700`)
      .join('&')}&display=swap`;
    if (existing) {
      (existing as HTMLLinkElement).href = href;
    } else {
      const link = Object.assign(document.createElement('link'), { id, rel: 'stylesheet', href });
      document.head.appendChild(link);
    }
  }
}
